<template>
  <div class="web-box-all">
    <ext-header></ext-header>
    <div class="web-home-main">
      <div class="web-cart-top">
        <h2>
          <b>全部商品 （{{cart_all_qty}}）</b>
          <span v-if="company_no=='MCD-CHN'" >剩余积分：{{user_info.integral}}</span>
        </h2>
      </div>
      <div class="web-cart-list">
        <div class="web-cart-list-title">
          <div class="web-cart-list-checkbox">
            <label>
              <div class="web-cart-list-checkbox-input">
                <input type="checkbox" v-model="all_checked" @click="all_select()"/>
              </div>
              全选
            </label>
          </div>
          <div class="web-cart-list-goods">商品</div>
          <div class="web-cart-list-props"></div>
          <div class="web-cart-list-price">单价</div>
          <div class="web-cart-list-quantity">数量</div>
          <div class="web-cart-list-sum">小计</div>
          <div class="web-cart-list-action">操作</div>
        </div>
        <div class="web-cart-list-title tip" v-if="spot_list.length">
          <div class="web-cart-list-checkbox">
            <label>
              <div class="web-cart-list-checkbox-input">
                <input type="checkbox" v-model="spot_checked" @click="spot_select()" />
              </div>
              现货产品
            </label>
          </div>
        </div>

        <div v-for="(vo,index) in spot_list" :key="index" class="web-cart-list-data">
          <div class="web-cart-list-checkbox">
            <label>
              <div class="web-cart-list-checkbox-input">
                <input type="checkbox" v-model="vo.checked" :data-index="index" @change="spot_checked_select"  />
              </div>
            </label>
            <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
          </div>
          <div class="web-cart-list-goods">
            <p>{{vo.goods_name}}</p>
            <a>{{vo.goods_no}}</a>
          </div>
          <div class="web-cart-list-props"></div>
          <div class="web-cart-list-price">
            <p>￥{{vo.goods_money}}</p>
          </div>
          <div class="web-cart-list-quantity">
            <p>
              <a @click="cart_del(index,'spot')">-</a>
              <input type="number" v-model.number="vo.qty" :data-index="index" data-type="spot" @blur.capture="input_out"/>
              <a @click="cart_add(index,'spot')">+</a>
            </p>
          </div>
          <div class="web-cart-list-sum">
            <p>￥{{numFilter(vo.goods_money*vo.qty)}}</p>
          </div>
          <div class="web-cart-list-action">
            <a @click="cart_delete(vo.goods_no)">删除</a>
          </div>
        </div>

      </div>

      <div class="web-cart-list">
        <div class="web-cart-list-title tip" v-if="stockout_list.length">
          <div class="web-cart-list-checkbox">
            <label>
              <div class="web-cart-list-checkbox-input">
                <input type="checkbox" v-model="stockout_checked" @click="stockout_select()" />
              </div>
              缺货产品
            </label>
          </div>
        </div>

        <div v-for="(vo,index) in stockout_list" :key="index"  class="web-cart-list-data">
          <div class="web-cart-list-checkbox">
            <label>
              <div class="web-cart-list-checkbox-input">
                <input type="checkbox" v-model="vo.checked" :data-index="index" @change="stockout_checked_select" />
              </div>
            </label>
            <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
          </div>
          <div class="web-cart-list-goods">
            <p>{{vo.goods_name}}</p>
            <a>{{vo.goods_no}}</a>
          </div>
          <div class="web-cart-list-props"></div>
          <div class="web-cart-list-price">
            <p>￥{{vo.goods_money}}</p>
          </div>
          <div class="web-cart-list-quantity">
            <p>
              <a @click="cart_del(index,'stockout')">-</a>
              <input type="number" v-model.number="vo.qty" :data-index="index" data-type="stockout" @blur.capture="input_out"/>
              <a @click="cart_add(index,'stockout')">+</a>
            </p>
          </div>
          <div class="web-cart-list-sum">
            <p>￥{{numFilter(vo.goods_money*vo.qty)}}</p>
          </div>
          <div class="web-cart-list-action">
            <a @click="cart_delete(vo.goods_no)">删除</a>
          </div>
        </div>
      </div>

      <div class="web-cart-footer">
          <div class="web-cart-list-checkbox" style="margin-top:5px; width:80px;">
            <label id="all_checked">
              <div class="web-cart-list-checkbox-input">
                <input type="checkbox" v-model="all_checked" @click="all_select()"/>
              </div>
              全选
            </label>
          </div>
          <div class="web-cart-footer-txt">
            <p @click="$bvModal.show('bv-modal-cart-select')">删除选中的商品</p>
          </div>
          <div class="web-cart-footer-txt">
            <p @click="$bvModal.show('bv-modal-cart-all')">清空购物车</p>
          </div>
          <div class="web-cart-order">
            <div class="web-cart-order-num">
              <p>已选择<b>{{select_qty}}</b>件商品</p>
            </div>
            <div class="web-cart-order-money">
              <p><span>总价：</span><b>￥{{sum_money}}</b></p>
            </div>
            <div class="web-cart-order-button">
              <a @click="order_submit()">结算</a>
            </div>
          </div>
      </div>

    </div>

    <div class="web-home-main" style="margin-top:50px;">
      <div class="web-home-title">
        <a></a>
        <p>推荐产品<i></i></p>
        <a></a>
      </div>
    </div>

    <div class="web-goods-main">
      <div class="web-home-goods">

        <div v-for="(vo,index) in list_data" :key="index" :class="[vo.select==1 ? 'web-home-goods-list active' : 'web-home-goods-list']" v-on:mouseover="changeActive(index,'list_data')" v-on:mouseout="removeActive(index,'list_data')">
          <div @click="get_goods_show(vo.goods_no)" :class="[vo.select==1 ? 'web-home-goods-list-data active' : 'web-home-goods-list-data']">
            <img src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
            <h2>{{vo.goods_name}}</h2>
            <h3>{{vo.goods_no}}</h3>
            <p>
              <i>¥</i><b>{{vo.goods_money}}</b>
            </p>
          </div>
        </div>

      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <b-modal id="bv-modal-cart-select" centered  hide-footer>
      <template #modal-title>
        提示
      </template>
      <div class="d-block text-center">
        <h6>确认删除选中的商品吗？</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('bv-modal-cart-select')" class="no">取消</a>
        <a @click="cart_delete();$bvModal.hide('bv-modal-cart-select')" class="ok">确定删除</a>
      </div>
    </b-modal>

    <b-modal id="bv-modal-cart-all" centered  hide-footer>
      <template #modal-title>
        提示
      </template>
      <div class="d-block text-center">
        <h6>确认清空购物车吗？</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('bv-modal-cart-all')" class="no">取消</a>
        <a @click="cart_delete('all');$bvModal.hide('bv-modal-cart-all')" class="ok">确定清空</a>
      </div>
    </b-modal>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, getCompanyNo} from '@/utils/extend'
import $ from 'jquery'
import Toast from '@/components/toast/index'

export default {
  name: 'cart_list',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '购物车',
      web_url: webUrl(),
      company_no: getCompanyNo(),
      all_checked: false,
      spot_checked: false,
      stockout_checked: false,
      user_info: {},
      nodata_txt: '',
      sum_money: '0.00',
      sum_integral: '0',
      cart_all_qty: '0',
      select_qty: '0',
      spot_list: [],
      stockout_list: [],
      list_data: [],
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    this.load_cart_list()
    this.recommend_list()
    this.load_user()

    setTimeout(function () {
      $('#all_checked').trigger('click')
    }, 2000)
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    numFilter (value) {
      var realVal = parseFloat(value).toFixed(2)
      return realVal
    },
    input_out (e) {
      var input = e.target._value
      var index = e.target.dataset['index']
      var type = e.target.dataset['type']
      if (input) {
        var goodsNo = this.spot_list[index].goods_no
        if (type === 'spot') {
          this.$set(this.spot_list[index], 'qty', input)
        } else {
          this.$set(this.stockout_list[index], 'qty', input)
        }

        this.sum_cart_info()
        this.updata_cart_qty(goodsNo, input)
      }
    },
    get_goods_show (goodsNo) {
      // let routeData = this.$router.resolve({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
      // window.open(routeData.href, '_blank')
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    all_select () {
      var spotList = this.spot_list
      var stockoutList = this.stockout_list
      var getAllChecked = this.all_checked
      var selectType = this.select_type
      var allChecked = false
      if (selectType === 'select') {
        this.select_type = ''
        this.all_select()
        return false
      }
      if (getAllChecked === true) {
        allChecked = false
        this.all_checked = allChecked
      } else {
        allChecked = true
        this.all_checked = allChecked
      }

      var selectIds = ''

      var spotListArr = []
      spotList.forEach(function (val) {
        if (allChecked) {
          selectIds += val['goods_no'] + ','
        }
        spotListArr.push({
          'id': val.id,
          'qty': val.qty,
          'goods_type': val.goods_type,
          'type_id': val.type_id,
          'integral': val.integral,
          'goods_no': val.goods_no,
          'goods_name': val.goods_name,
          'goods_remark': val.goods_remark,
          'goods_image': val.goods_image,
          'goods_money': val.goods_money,
          'goods_qty': val.goods_qty,
          'checked': allChecked
        })
      })

      var stockoutListArr = []
      stockoutList.forEach(function (val) {
        if (allChecked) {
          selectIds += val['goods_no'] + ','
        }
        stockoutListArr.push({
          'id': val.id,
          'qty': val.qty,
          'goods_type': val.goods_type,
          'type_id': val.type_id,
          'integral': val.integral,
          'goods_no': val.goods_no,
          'goods_name': val.goods_name,
          'goods_remark': val.goods_remark,
          'goods_image': val.goods_image,
          'goods_money': val.goods_money,
          'goods_qty': val.goods_qty,
          'checked': allChecked
        })
      })

      this.spot_checked = allChecked
      this.stockout_checked = allChecked

      this.spot_list = spotListArr
      this.stockout_list = stockoutListArr
      this.select_type = 'all'
      this.sum_cart_info()
    },
    spot_select () {
      var that = this
      var spotList = this.spot_list
      var checked = false
      if (this.spot_checked === true) {
        checked = false
      } else {
        checked = true
      }

      var spotListArr = []

      spotList.forEach(function (val) {
        spotListArr.push({
          'id': val.id,
          'qty': val.qty,
          'goods_type': val.goods_type,
          'type_id': val.type_id,
          'integral': val.integral,
          'goods_no': val.goods_no,
          'goods_name': val.goods_name,
          'goods_remark': val.goods_remark,
          'goods_image': val.goods_image,
          'goods_money': val.goods_money,
          'goods_qty': val.goods_qty,
          'checked': checked
        })
      })

      that.spot_checked = checked
      that.spot_list = spotListArr
      that.select_type = 'spot'
      that.sum_cart_info()
      that.jump_all_checked()
    },
    stockout_select () {
      var that = this
      var stockoutList = this.stockout_list
      var checked = false
      if (this.stockout_checked === true) {
        checked = false
      } else {
        checked = true
      }

      var stockoutListArr = []

      stockoutList.forEach(function (val) {
        stockoutListArr.push({
          'id': val.id,
          'qty': val.qty,
          'goods_type': val.goods_type,
          'type_id': val.type_id,
          'integral': val.integral,
          'goods_no': val.goods_no,
          'goods_name': val.goods_name,
          'goods_remark': val.goods_remark,
          'goods_image': val.goods_image,
          'goods_money': val.goods_money,
          'goods_qty': val.goods_qty,
          'checked': checked
        })
      })

      that.stockout_checked = checked
      that.stockout_list = stockoutListArr
      that.select_type = 'stockout'
      that.sum_cart_info()
      that.jump_all_checked()
    },
    spot_checked_select (event) {
      var index = event.target.dataset['index']
      var checked = event.target.checked
      this.spot_list[index].checked = checked
      this.select_type = 'select'
      this.sum_cart_info()
      this.jump_all_checked()
    },
    stockout_checked_select (event) {
      var index = event.target.dataset['index']
      var checked = event.target.checked
      this.stockout_list[index].checked = checked
      this.select_type = 'select'
      this.sum_cart_info()
      this.jump_all_checked()
    },
    jump_all_checked () {
      var that = this
      var spotList = this.spot_list
      var stockoutList = this.stockout_list

      var selectType = this.select_type
      if (selectType === 'all') {
        return false
      }

      // 判斷是否全选
      var spotCheckedCount = 0
      spotList.forEach(function (val) {
        if (val.checked === true) {
          spotCheckedCount = spotCheckedCount + 1
        }
      })

      var stockoutCheckedCount = 0
      stockoutList.forEach(function (val) {
        if (val.checked === true) {
          stockoutCheckedCount = stockoutCheckedCount + 1
        }
      })

      var spotChecked = false
      if (spotList.length === spotCheckedCount) {
        that.spot_checked = true
        spotChecked = true
      } else {
        that.spot_checked = false
        spotChecked = false
      }

      var stockoutChecked = false
      if (stockoutList.length === stockoutCheckedCount) {
        that.stockout_checked = true
        stockoutChecked = true
      } else {
        that.stockout_checked = false
        stockoutChecked = false
      }

      var allChecked = false
      if ((spotList.length + stockoutList.length) === (spotCheckedCount + stockoutCheckedCount)) {
        that.all_checked = true
        allChecked = true
      } else {
        that.all_checked = false
        allChecked = false
      }
    },
    cart_del (index, name) {
      var setQty = 0
      var qty = 0
      var goodsNo = ''
      if (name === 'spot') {
        qty = this.spot_list[index].qty
        if (qty > 1) {
          setQty = parseInt(qty) - 1
          this.$set(this.spot_list[index], 'qty', setQty)
        } else {
          setQty = 1
          this.$set(this.spot_list[index], 'qty', setQty)
        }
        goodsNo = this.spot_list[index].goods_no
      } else {
        qty = this.stockout_list[index].qty
        if (qty > 1) {
          setQty = parseInt(qty) - 1
          this.$set(this.stockout_list[index], 'qty', setQty)
        } else {
          setQty = 1
          this.$set(this.stockout_list[index], 'qty', setQty)
        }
        goodsNo = this.stockout_list[index].goods_no
      }

      this.sum_cart_info()
      this.updata_cart_qty(goodsNo, setQty)
    },
    cart_add (index, name) {
      var setQty = 0
      var qty = 0
      var goodsNo = ''
      if (name === 'spot') {
        qty = this.spot_list[index].qty
        goodsNo = this.spot_list[index].goods_no
        setQty = parseInt(qty) + 1
        this.$set(this.spot_list[index], 'qty', setQty)
      } else {
        qty = this.stockout_list[index].qty
        goodsNo = this.stockout_list[index].goods_no
        setQty = parseInt(qty) + 1
        this.$set(this.stockout_list[index], 'qty', setQty)
      }
      this.sum_cart_info()
      this.updata_cart_qty(goodsNo, setQty)
    },
    sum_cart_info () {
      var spotList = this.spot_list
      var stockoutList = this.stockout_list

      var selectQty = 0
      var selectAllQty = 0
      var spotMoney = 0
      var spotIntegral = 0
      var stockoutMoney = 0
      var stockoutIntegral = 0

      spotList.forEach(function (val) {
        if (val.checked === true) {
          if (val['integral'] > 0) {
            spotIntegral += parseInt(val['integral']) * parseInt(val['qty'])
          } else {
            spotMoney += parseFloat(val['goods_money']) * parseInt(val['qty'])
          }
          selectQty += 1
        }
        selectAllQty += 1
      })

      stockoutList.forEach(function (val) {
        if (val.checked === true) {
          if (val['integral'] > 0) {
            stockoutIntegral += parseInt(val['integral']) * parseInt(val['qty'])
          } else {
            stockoutMoney += parseFloat(val['goods_money']) * parseInt(val['qty'])
          }
          selectQty += 1
        }
        selectAllQty += 1
      })

      this.sum_money = (spotMoney + stockoutMoney).toFixed(2)
      this.sum_integral = spotIntegral + stockoutIntegral
      this.select_qty = selectQty
      this.cart_all_qty = selectAllQty
    },
    updata_cart_qty (goodsNo, qty) {
      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          goods_no: goodsNo,
          qty: qty
        }
      }, function (ret) {
      })
    },
    changeActive (index, list) {
      this.$set(this['' + list][index], 'select', '1')
    },
    removeActive (index, list) {
      this.$set(this['' + list][index], 'select', '0')
    },
    order_submit () {
      var selectIds = ''
      var spotList = this.spot_list
      var stockoutList = this.stockout_list
      spotList.forEach(function (val) {
        if (val.checked) {
          selectIds += val['goods_no'] + ','
        }
      })

      stockoutList.forEach(function (val) {
        if (val.checked) {
          selectIds += val['goods_no'] + ','
        }
      })

      if (selectIds) {
        this.$router.push({path: '/cart/order_submit', query: {v: Encrypt(selectIds)}})
      } else {
        this.toast('请选择一个商品')
      }
    },
    load_cart_list () {
      var that = this
      ajax({
        url: '/store/order/user_cart_list',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var spotList = ret.data.spot_list
          var stockoutList = ret.data.stockout_list

          that.all_checked = false
          that.spot_checked = false
          that.stockout_checked = false
          that.sum_money = '0.00'
          that.sum_integral = '0'
          that.select_qty = '0'
          that.cart_all_qty = spotList.length + stockoutList.length
          // 判断购物车状态
          var spotListArr = []
          var stockoutListArr = []

          spotList.forEach(function (val) {
            spotListArr.push({
              'id': val.id,
              'qty': val.qty,
              'goods_type': val.goods_type,
              'type_id': val.type_id,
              'integral': val.integral,
              'goods_no': val.goods_no,
              'goods_name': val.goods_name,
              'goods_remark': val.goods_remark,
              'goods_image': val.goods_image,
              'goods_money': val.goods_money,
              'goods_qty': val.goods_qty,
              'checked': false
            })
          })

          stockoutList.forEach(function (val) {
            stockoutListArr.push({
              'id': val.id,
              'qty': val.qty,
              'goods_type': val.goods_type,
              'type_id': val.type_id,
              'integral': val.integral,
              'goods_no': val.goods_no,
              'goods_name': val.goods_name,
              'goods_remark': val.goods_remark,
              'goods_image': val.goods_image,
              'goods_money': val.goods_money,
              'goods_qty': val.goods_qty,
              'checked': false
            })
          })

          that.spot_list = spotListArr
          that.stockout_list = stockoutListArr
        } else {
          that.spot_list = []
          that.stockout_list = []
          that.no_page_state = true
          that.spot_list = []
          that.stockout_list = []
          that.nodata_txt = ret.msg
          that.sum_money = '0.00'
          that.select_qty = '0'
        }
      })
    },
    recommend_list () {
      var that = this
      ajax({
        url: '/store/home/recommend_cart_list_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.title = ret.data.title
          var list = ret.data
          that.list_data = list
        } else {
          that.list_data = []
        }
      })
    },
    cart_delete (id) {
      var that = this
      var spotList = this.spot_list
      var stockoutList = this.stockout_list
      var selectIds = ''

      var selectCartIds = ''
      if (id === 'all') {
        spotList.forEach(function (val) {
          selectIds += val['goods_no'] + ','
        })

        stockoutList.forEach(function (val) {
          selectIds += val['goods_no'] + ','
        })
        selectCartIds = selectIds
      } else if (id && id !== 'all') {
        selectCartIds = id
      } else {
        spotList.forEach(function (val) {
          if (val.checked) {
            selectIds += val['goods_no'] + ','
          }
        })

        stockoutList.forEach(function (val) {
          if (val.checked) {
            selectIds += val['goods_no'] + ','
          }
        })
        selectCartIds = selectIds
      }

      if (selectCartIds) {
        ajax({
          url: '/store/order/cart_list_del',
          method: 'post',
          data: {
            uid: getUserId(),
            ids: selectCartIds
          }
        }, function (ret) {
          if (ret && ret.code === 'success') {
            that.load_cart_list()
          }
        })
      } else {
        this.toast('请选择一个商品')
      }
    },
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-cart-top { width:100%; height:40px; margin-top:15px; background: #ffffff; flex-flow:row; justify-content:flex-start;}
  .web-cart-top h2 { width:100%; line-height:40px; height:40px; margin:0px; padding:0px 15px; flex-flow:row; justify-content:space-between; }
  .web-cart-top h2 b { width:auto; height:40px; line-height:40px; float:left; margin:0px; padding:0px; font-size:16px; color:#d81e06; margin-right:20px; font-weight: normal;}
  .web-cart-top h2 span { font-size:14px; color:#666666;}
.web-cart-list { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
  .web-cart-list-title { width:100%; height:40px; background: #efefef; border:1px solid #dfdfdf;}
  .web-cart-list-title.tip  {  background: #ffffff; border:0px; margin-top: 5px; font-weight: bold; border-bottom:3px solid #dfdfdf;}
  .web-cart-list-checkbox { width:140px; height:auto;  -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox label { width:auto; height:auto; cursor: pointer; position: relative; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox-input { width:20px; height:100%; line-height:40px; position: relative; margin:0px 10px 0px 10px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox-input input { width:18px; height:18px; position: absolute; top:50%; left:1px; margin-top:-9px; padding:0px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 0px;}
  .web-cart-list-goods { width:210px; height:auto; line-height:40px; font-size:14px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
  .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:14px; color:#aaaaaa;}
  .web-cart-list-goods a:hover { color:#aaaaaa;}
  .web-cart-list-props {width:140px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-props p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-price {width:120px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-price p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-quantity { width:170px; height:auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; text-align: center;justify-content:center; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-quantity p { width:136px; height:40px; line-height:40px; overflow: hidden; flex-flow:row; justify-content:flex-start; margin-top:35px; border:1px solid #dfdfdf;}
  .web-cart-list-quantity p a { width: 40px; height: 40px; cursor: pointer; background: #efefef; font-size:28px; color:#333333; line-height:34px; text-align: center; justify-content:center;}
  .web-cart-list-quantity p input { width: 55px; height:38px; line-height:38px; text-align: center; font-size:14px; color:#333333; border:0px; min-height: 20px;}
  .web-cart-list-sum { width:100px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-sum p { width:100%; height:auto; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:14px; color:#333333;}
  .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:80px; margin-top:15px; font-size:14px; color:#333333;}

  .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}

  .web-cart-footer { width:100%; height:50px; flex-flow:row; position: relative; border:1px solid #dfdfdf; margin-top:20px; justify-content:flex-start; }
    .web-cart-footer-txt { width:auto; height:50px; margin-right:10px;}
    .web-cart-footer-txt p { width:auto; height:50px; cursor: pointer; line-height: 50px; font-size:14px; color:#666666}
    .web-cart-order { width:auto; height:50px; position: absolute; right:0px; top:0px;}
    .web-cart-order-num { width:auto; height:50px; margin-right:10px;}
      .web-cart-order-num p { width:auto; height:50px; line-height:50px; font-size:14px;}
      .web-cart-order-num p b { font-size:14px; color:#d81e06;}
    .web-cart-order-money { width:auto; height:50px; line-height:50px; font-size:14px; margin-right:10px;}
      .web-cart-order-money p { width:auto; height:50px; line-height:50px; font-size:14px;}
      .web-cart-order-money p span { width:auto; height:50px; line-height:50px; font-size:14px;color:#333333;}
      .web-cart-order-money p b { width:auto; height:50px; line-height:50px; font-size:16px;color:#d81e06;}
    .web-cart-order-button { width:100px; height:50px;}
      .web-cart-order-button a { width:100px; height:50px; cursor: pointer; color:#ffffff !important; background: #d81e06; line-height:50px; text-align: center; justify-content:center;}
      .web-cart-order-button a:hover { color:#ffffff;}

      .web-home-title { width:100%; height:50px; position: relative; flex-flow:row; justify-content:center; display: flex; margin-top:15px;}
  .web-home-title a { width:100px; height:10px; background: url('https://parts.franke.cn/static/image/line001.png') repeat-x; margin-top:22px; flex:1;}
  .web-home-title p { width:auto; padding:0px 15px; position: relative; box-sizing: border-box; height:50px; line-height: 50px; font-size:24px; color:#333333; text-align: center; justify-content:center;}
  .web-home-title p i { width:24px; height:1px; border-top:3px solid #d81e06; position: absolute; bottom:0px; left:50%; margin-left:-12px;}
  .web-home-title b { width:80px; cursor: pointer; height:50px; text-align: right; font-weight: normal; line-height:50px; font-size:14px; background: #ffffff; color:#666666; position: absolute; right: 0px; top:0px;}

/* 商品列表 */
.web-goods-main { width:1020px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-goods { width:100%; height:auto; margin-top:10px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
  .web-home-goods-list { width:255px; height:370px; position: relative; margin:5px 0px; padding:10px; border:1px solid #ffffff;}
  .web-home-goods-list.active { border:1px solid #d81e06;}
  .web-home-goods-list-data { width:233px; height:350px; cursor: pointer; border:1px solid #e7e7e7; flex-wrap:wrap; align-content:flex-start;}
  .web-home-goods-list-data.active { border:1px solid #ffffff;}
  .web-home-goods-list-data img { width:100%; height:230px; padding:10px 10px 0px 10px; object-fit: cover;}
  .web-home-goods-list-data h2 { width:223px; height:40px; display:-webkit-box;text-overflow:ellipsis; overflow:hidden; -webkit-line-clamp: 2; -webkit-box-orient:vertical; line-height:20px; margin:5px 0px; font-size:14px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data h3 { width:233px; height:20px; line-height:20px; margin:0px; font-size:14px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data p { width:233px; height:40px; padding:0px 10px; margin:0px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list-data p i { font-size:14px; margin-right:5px; margin-top:10px; font-style:normal; color:#d81e06;}
  .web-home-goods-list-data p b { font-size:22px; color:#d81e06;}
  .web-home-goods-list h4 { width:223px; height:40px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; position: absolute; left:15px; bottom: 10px; z-index: 99; margin:0px; padding:0px 10px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list h4 b { font-size:14px; line-height:30px; float:left; font-weight: normal;}
  .web-home-goods-list h4 b.del { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num { width:44px; height:30px; overflow: hidden; border-top:1px solid #e7e7e7; border-bottom:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num input { width:44px; height:20px; margin-top:5px; text-align: center; line-height:20px; font-size:14px; color:#333333; min-height:20px; border:0px;}
  .web-home-goods-list h4 b.add { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.cart { width:90px; height:30px; cursor: pointer; margin-left:8px; text-align: center; line-height:30px; background: #d81e06; font-size:13px; color:#ffffff;}

</style>



// WEBPACK FOOTER //
// src/pages/cart/cart_list.vue